<template>
  <el-dialog
    title="上传附件"
    :visible.sync="uploadFileDialogVisible"
    width="600px"
    top="15%"
  >
    <el-form
      ref="fileFormRef"
      :model="fileForm"
      :rules="dynamicRules"
      label-position="top"
    >
      <el-row :gutter="24" class="file-box stamped-contract">
        <template v-if="form.isMail == 'Y'">
          <el-col :span="12" class="mt12">
            <div>快递公司<span class="fontC-red">*</span></div>
            <el-form-item prop="expressCompany" class="mb0">
              <el-input
                v-model="fileForm.expressCompany"
                class="mt2"
                placeholder="请输入"
                maxlength="30"
                clearable
                style="height: 32px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="mt12">
            <div>快递单号<span class="fontC-red">*</span></div>
            <el-form-item prop="expressNo" class="mb0">
              <el-input
                v-model="fileForm.expressNo"
                class="mt2"
                placeholder="请输入"
                maxlength="30"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </template>

        <el-col :span="24" class="mb0 mt14">
          <div>上传合同盖章附件<span class="fontC-red">*</span></div>
          <el-form-item prop="electronicContractFileList" class="mb0">
            <el-upload
              class="upload-demo"
              action="#"
              multiple
              :limit="5"
              accept=".pdf,.docx,.doc"
              :on-exceed="handleExceed"
              :on-remove="handleFileRemove"
              :http-request="uploadFile"
              :file-list="fileForm.electronicContractFileList"
              :before-upload="beforeAvatarUpload"
            >
              <el-button
                class="mt2"
                size="mini"
                icon="el-icon-my-import"
                style="margin-bottom: 0"
                type="importNew"
                >上传文件</el-button
              >
              <span slot="tip" class="el-upload__tip fontC-999">
                支持.pdf,.docx,.doc文件，单个文件不得大于20M
              </span>
              <template #file="{ file }">
                <div class="flex justify-between w-550">
                  <div class="flex items_center">
                    <img
                      width="20"
                      height="20"
                      class="mr10"
                      :src="getIconSrc(file.name)"
                      alt=""
                    />
                    <span>
                      {{ formatFileName(file.name) }}
                    </span>
                  </div>
                  <div class="flex items_center">
                    <el-button type="text" @click="handlePreview(file)"
                      >查看</el-button
                    >
                    <el-button
                      type="text"
                      class="ml10 mr10"
                      @click="handleDownload(file)"
                      >下载</el-button
                    >
                    <el-button type="text" @click="handleFileRemove(file)">
                      删除
                    </el-button>
                  </div>
                </div>
              </template>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        type=""
        class="w60 btn"
        @click="uploadFileDialogVisible = false"
        >取消</el-button
      >
      <el-button type="info" class="w60" @click="submitForm">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["onChangeFullscreenLoading", "getList"],
  data() {
    return {
      uploadFileDialogVisible: false,
      fileUrl: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`,
      fileForm: {
        contractGuid: null,
        expressNo: null,
        expressCompany: null,
        electronicContractFileList: [],
      },
      form: {},
    };
  },
  computed: {
    dynamicRules() {
      return {
        expressCompany: [
          {
            required: this.form.isMail == "Y",
            message: "请输入快递公司",
            trigger: "blur",
          },
        ],
        expressNo: [
          {
            required: this.form.isMail == "Y",
            message: "请输入快递单号",
            trigger: "blur",
          },
        ],
        electronicContractFileList: [
          { validator: this.validateFileList, trigger: "change" },
        ],
      };
    },
  },
  methods: {
    validateFileList(rule, value, callback) {
      if (
        !this.fileForm.electronicContractFileList ||
        this.fileForm.electronicContractFileList.length === 0
      ) {
        callback(new Error("请上传合同盖章附件"));
      } else {
        callback();
      }
    },
    open(data) {
      this.fileForm = data;
      this.form = data.form;
      this.uploadFileDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.fileFormRef && this.$refs.fileFormRef.clearValidate();
      });
    },

    // 提交表单
    async submitForm() {
      const valid = await this.$refs.fileFormRef.validate();
      if (!valid) return false;

      this.fileForm.electronicContractFileList =
        this.fileForm.electronicContractFileList.map((item) => {
          return {
            fileName: item.name,
            path: item.path,
          };
        });

      const userInfo = JSON.parse(localStorage.userInfo);
      const query = {
        ...this.fileForm,
        currentStaffGuid: userInfo.staffGuid,
        form: null,
      };

      this.onChangeFullscreenLoading(true);

      const { data } = await this.api.postJson(
        `/${serverConfig.msCustomerService}/contract/save-approve-contract-end-info`,
        query
      );
      this.onChangeFullscreenLoading(false);
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.$message({
        message: "提交成功",
        type: "success",
      });
      this.uploadFileDialogVisible = false;
      this.getList();
    },

    async uploadFile(file) {
      this.onChangeFullscreenLoading(true);
      const formData = new FormData();
      formData.append("file", file.file);
      // /[!@#$%^&*()_+\-=\[\]{}|;:'",<>\/?]/g
      formData.append("fileName", file.file.name?.replace(/[#+%]/g, ""));
      const { data } = await this.api.postImage(this.fileUrl, formData);
      this.onChangeFullscreenLoading(false);
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.fileForm.electronicContractFileList = [];
        this.$message.error("上传失败!");
        return;
      }

      const item = {
        name: file.file.name?.replace(/[#+%]/g, ""),
        path: data.data.data,
      };
      this.fileForm.electronicContractFileList.push(item);
      this.$message({
        message: "上传成功",
        type: "success",
      });
      // 触发验证
      this.$refs.fileFormRef.validateField("electronicContractFileList");
    },

    //上传限制
    beforeAvatarUpload(file) {
      const maxSize = file.size / 1024 / 1024 < 20;
      if (!maxSize) {
        this.$message({
          message: `上传文件大小不能超过 20MB!`,
          type: "warning",
        });
      }
      return maxSize;
    },

    // 查看附件
    handlePreview(file) {
      const url = file.path;
      if (url.indexOf(".pdf" || ".PDF") > -1) {
        window.open(url);
      } else {
        window.open(
          "https://view.officeapps.live.com/op/view.aspx?src=" +
            encodeURIComponent(url)
        );
      }
    },

    // 下载
    handleDownload(file) {
      window.open(file.path);
    },

    //移除文件
    handleFileRemove(file) {
      let self = this;
      self.fileForm.electronicContractFileList.forEach(function (i, index) {
        if (i.path == file.path) {
          self.fileForm.electronicContractFileList.splice(index, 1);
        }
      });
      // 触发验证
      this.$refs.fileFormRef.validateField("electronicContractFileList");
    },

    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },

    getIconSrc(name) {
      name = name.toLowerCase();
      if (name.endsWith(".pdf")) {
        return require("../../../assets/images/pdf_icon.png");
      } else if (name.endsWith(".doc") || name.endsWith(".docx")) {
        return require("../../../assets/images/word_icon.png");
      } else {
        return "";
      }
    },

    formatFileName(filename, maxLength = 15) {
      const lastDotIndex = filename.lastIndexOf(".");
      if (lastDotIndex === -1 || filename.length <= maxLength) {
        return filename;
      }
      const name = filename.substring(0, lastDotIndex);
      const extension = filename.substring(lastDotIndex);
      if (name.length > maxLength) {
        return name.substring(0, maxLength) + "..." + extension;
      }
      return filename;
    },
  },
};
</script>

<style scoped lang="less">
.w-550 {
  width: 550px;
}
/deep/ .el-dialog__header {
  text-align: left;
  border-bottom: 1px solid #d9d9d9;
}
/deep/ .el-dialog__body {
  padding: 0 20px;
}

/deep/ .el-form-item__content {
  line-height: 0;
}
/deep/ .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.stamped-contract {
  text-align: left;
}
.file-box .search-area-div {
  flex-shrink: 0;
  width: 140px;
  word-break: keep-all;
}

.search-area-div {
  width: 90px;
  text-align: right;
}

/* 调整表单样式 */
.el-form-item {
  margin-bottom: 0;
}

/* 必填项星号样式 */
.fontC-red {
  color: #f56c6c;
  margin-right: 4px;
}

/* 上传区域样式 */
.upload-demo {
  width: 100%;
}

/* 对话框底部按钮样式 */
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.w100f {
  width: 100%;
}
.el-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
}
.mt2 {
  margin-top: 2px;
}

.btn {
  color: #212121;
  border: 1px solid #d9d9d9;
}
/deep/ .el-button {
  line-height: 2;
}
</style>
